import { AllUserInfoModel } from './../../../store/storeModels/user.model';
import { Store } from '@ngrx/store';
import { TicketChatService } from 'src/app/services/ticket/ticket-chat.service';
import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/store/app.state';
import { LocalStorageService } from '../../../utils/LocalStorage';
import { ChatService } from 'src/app/services/chat.service';
import { TicketService } from 'src/app/services/ticket/ticket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-support-chat',
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.css']
})
export class SupportChatComponent implements OnInit {
  ticketCode;
  inputMsg = ''
  chats: any[];
  chatClosed = false;
  loading = false;
  allUserInfo: AllUserInfoModel;
  autoReplyMsg = 'Thank you for contacting us. Your ticket code is - [[TicketCode]], an agent will respond shortly.'
  surveyUrl = `${environment.notchFrontendServiceUrl}/customer-survey`;
  msgCount = 1;
  closedChatMsg: any;
  ticketType: any;
  orgId: any;
  constructor(
    store: Store<AppState>,
    private localStorage: LocalStorageService,
    private ticketsrv: TicketService,
    private chatsrv: ChatService,
    private ticketChatSrv: TicketChatService) {
    store.select('userInfo').subscribe(info => this.allUserInfo = info);
  }

  ngOnInit() {
    this.fetchMessageHistory();
  }
  fetchMessageHistory() {
    this.getMessageHistory();

  }
  getMessages() {
    if (this.ticketCode){
      this.ticketChatSrv.fetchChat(this.ticketCode).subscribe(res => {
        this.chats = res.filter(chat => this.msgNotoShow(chat.message));
        this.chats = res.map(chat => ({...chat, message: this.extractMessage(chat.message)}));
        this.scrollToBottom();
      });
    } else {
      this.chats = [];
    }
  }
  async getMessageHistory(){
    this.ticketCode = JSON.parse(this.localStorage.getFromLocalStorage("customerchat-ticketCode"));
    if (this.ticketCode){
      this.ticketChatSrv.fetchChat(this.ticketCode).subscribe(data => {
        this.ticketChatSrv.getTicketByCode(this.ticketCode).subscribe(res => {
          if(res.closed === false){
            this.joinWebchat(this.ticketCode);
            this.chats = data.filter(chat => this.msgNotoShow(chat.message));
            this.chats = data.map(chat => ({...chat, message: this.extractMessage(chat.message)}));
            this.scrollToBottom();
          } else {
            this.chats = [];
          }
          
        })
      });
    } else {
      this.chats = [];
    }

  };

  sendMessage() {
    const message = this.inputMsg || this.autoReplyMsg;
    if (!message) return;
    const payload = { message };
    this.loading = true;
    if (this.chats.length === 0){
      this.createTicket(message);
    } else {
    this.ticketChatSrv.sendWebChatMsg(payload).subscribe(res => {
      this.inputMsg = '';
      this.msgCount++;
      this.ticketCode = res.ticketCode;
      this.localStorage.saveToLocalStorage('customerchat-ticketCode', this.ticketCode);
      this.sendWebChatSocketMsg(message);
      this.getMessages();
    }).add(() => this.loading = false);
    }
    
  }

  createNewTicket(){
    this.localStorage.deleteFromLocalStorage('customerchat-ticketCode');
    this.ticketCode = "";
    this.autoReplyMsg = 'Thank you for contacting us. Your ticket code is - [[TicketCode]], an agent will respond shortly.'
    this.chats = []
    this.chatClosed = false;
  }

  createTicket(msg) {
    const { organization, user } = this.allUserInfo;
    const message = `
    ------------ New Chat ------------<br>
      <b>Organization Name:</b> ${organization.name} <br>
      <b>User Name:</b> ${user.firstName} ${user.lastName} <br>
      <b>User Email:</b> ${user.email} <br>
      <b>Message:</b> ${msg} <br>
    `;
    const payload = { message };
    this.ticketChatSrv.sendWebChatMsg(payload).subscribe((res) => {
      const newTicketCode = res.ticketCode;
      this.inputMsg = "";
      this.autoReplyMsg = this.autoReplyMsg.replace("[[TicketCode]]", newTicketCode);
      this.ticketCode = newTicketCode;
      this.sendToSite(this.autoReplyMsg);
      this.ticketsrv.getTicketByCode(newTicketCode).subscribe((res) => {
        this.ticketType = res.type
        this.orgId = res.orgID
      const editPayload = { code: newTicketCode, type: this.ticketType };
      this.ticketsrv.editTicketS(editPayload).subscribe(() => {
        this.ticketsrv.getAutoAssignSettingByOrgIDForTenant().subscribe((autoSttngs) => {
          if (autoSttngs && autoSttngs.payload) {
            const { on: auto_assign_status, setting } = autoSttngs.payload;
            if (auto_assign_status) {
              const autoStngsPayload = {
                type: this.ticketType,
                code: newTicketCode,
                orgId: this.orgId, 
                setting,
                messageContent: message,
                sender: user.email,
                source: "WEBSITE",
              };
              console.log('autoStngsPayload', autoStngsPayload)
              this.chatsrv.autoAssignTicket(autoStngsPayload).subscribe(
                () => console.log("Auto-assignment triggered"),
                (err) => console.error("Error in auto-assignment:", err)
              );
            }
          }
        });
      });
    })
  
      this.joinWebchat(this.ticketCode);
      this.sendWebChatSocketMsg(this.autoReplyMsg);
      this.localStorage.saveToLocalStorage("customerchat-ticketCode", this.ticketCode);
      this.getMessages();
    }).add(() => (this.loading = false));
  }
  scrollToBottom() {
    setTimeout(() => {
      const objDiv = document.getElementById("chat-sectionId");
      objDiv.scrollTop = objDiv.scrollHeight;
    }, 1000);
  }
  msgNotoShow(msg: string) {
    if (msg == 'null') {
      return false
    } else {
      return true
    }
  }

  extractMessage(payload) {
    if (payload.includes('------------ New Chat ------------')) {
        const cleanPayload = payload.replace(/<br>/g,'\n').replace(/<br>/g, '\n').trim();

        const messageStart = cleanPayload.indexOf('Message:');
        if (messageStart !== -1) {
            return cleanPayload.slice(messageStart + 'Message:'.length).trim();
        }
        return null;
    } else {
      return payload;
    }
  }
  saveAutoReplyMsg(message) {
    if (this.msgCount === 1) {
      const payload = { message, ticketCode: this.ticketCode };
      this.ticketChatSrv.sendWebChatMsg(payload, 'sendToSite').subscribe(() => {
        this.getMessages();
      })
    }

  }

  sendToSite(message){
    const payload = { message, ticketCode: this.ticketCode };
      this.ticketChatSrv.sendWebChatMsg(payload, 'sendToSite').subscribe(() => {
        this.getMessages();
      })
  };

  joinWebchat(ticketCode) {
    this.ticketChatSrv.joinWebchat(ticketCode).subscribe(res => { });
    this.recieveWebChatMsg();
  }
  recieveWebChatMsg() {
    this.ticketChatSrv.recieveWebChatMsg().subscribe((res: any) => {
      const payload = { ...res, message: res.msg, type: 2 }
      if(res.isClosed){
        this.closedChatMsg = res.msg
        this.chatClosed = true;
      } else {
        if (this.chats) {
          this.chats.push(payload);
        } else {
          this.chats = [];
          this.chats.push(payload);
        }
        setTimeout(() => {
          this.getMessages();
        }, 500);
        this.scrollToBottom();
      }
    })
  }
  sendWebChatSocketMsg(msg) {
    const ticketCode = this.ticketCode;
    this.ticketChatSrv.sendWebChatSocketMsg({ ticketCode, msg }).subscribe(res => {
    })
  }

}
